var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataListStateful',{attrs:{"title":"Маршруты","resource":"routes","columns":_vm.columns,"store":"routes","disable-adding":true,"filter-options":_vm.filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }